<template>
  <div :class="{ card: true, loading: value }" :style="{ height: height }">
    <slot></slot>
    <template v-if="value">
      <div class="icon">
        <img src="../assets/images/loading.svg" alt />
        <span>{{getLabel}}</span>
      </div>
    </template>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: 'auto'
    },
    active: {
      type: String,
      default: 'img'
    }
  },
  computed: {
    getLabel () {
      return this.value ? '发表中。。。' : '发表成功'
    }
  },
  watch: {
    value (val) {
      if (!val) {
        if (this.active !== 'video') {
          Toast.success('发表成功')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes loading-animation {
  form {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.card {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .icon {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
     background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    img {
      width: 24px;
      height: 24px;
      display: block;
      animation: loading-animation linear infinite 1s;
      margin-right: 10px;
    }
  }
}
</style>
